export const RavenNotePlaceholder = "Gender: \nEstimated Age/Age: \nPresenting:\n\nAdd Incident Notes: ";
